import ENDPOINTS from "@/providers/end-points";
import requests from "@/providers/requests";
import { Merchant, OverView } from "@/modules/ooc";

export default {
  namespaced: true,
  state: {
    list: [],
    count: 0,
    singleMerchant: "",
    merchantInfo: null,
    locations: [],
    overview: null,
  },

  getters: {
    list: (state: any): Array<any> => state.list,
    totalRows: (state: any): number => state.totalRows,
    getSingleMerchant: (state: any): string => state.singleMerchant,
    getMerchantInfo: (state: any): any => state.merchantInfo,
    locations: (state: any): any => state.locations,
    overview: (state: any): any => state.overview,
  },

  mutations: {
    SET_MERCHANT_LIST(state: any, payload) {
      state.list = payload.data;
      state.count = payload.count;
    },

    SET_MERCHANT_INFO(state: any, payload) {
      state.singleMerchant = payload.name;
      state.merchantInfo = payload;
    },

    SET_MERCHANT_LOCATION(state: any, payload) {
      state.locations = payload;
    },

    SET_MERCHANT_OVERVIEW(state: any, payload) {
      state.overview = payload;
    },
  },

  actions: {
    /**
     * get a list of all merchants
     * @param {payload}
     **/
    async getMerchants({ commit }: { commit: any }, payload) {
      const { page = 1, itemsPerPage = 15, search = "" } = payload;
      return await requests
        .get(
          `${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.MERCHANTS}?page=${page}&page_size=${itemsPerPage}&name=${search}`
        )
        .then((response) => response.data)
        .then(({ data, meta }) => ({
          data: data.map((item) => new Merchant(item)),
          count: meta.total_records || 0,
        }))
        .then(async ({ data, count }) => {
          await commit("SET_MERCHANT_LIST", { data, count });
        })
        .catch(async (error) => {
          await console.log(error);
        });
    },

    /**
     * get a one merchant
     * @param {payload}
     **/
    async getMerchant({ commit }: { commit: any }, payload) {
      return await requests
        .get(`${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.ONE_MERCHANT(payload)}`)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_MERCHANT_INFO", data);
        })
        .catch(async (error) => {
          await console.log(error);
        });
    },

    /**
     * handle on get locations
     * @param commit
     * @param payload
     */
    async getLocations({ commit }: { commit: any }, payload) {
      return await requests
        .get(`${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.LOCATIONS(payload)}`)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_MERCHANT_LOCATION", data);
        })
        .catch(async (error) => {
          await console.log(error);
        });
    },

    /**
     *  handle to Get Over View data for menu page
     *  @params {payload}
     */
    async getOverview({ commit }: { commit: any }, payload) {
      return await requests
        .get(`${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.MERCHANT_OVERVIEW(payload)}`)
        .then((response) => response.data)
        .then(({ data }) => new OverView(data))
        .then(async (data) => {
          await commit("SET_MERCHANT_OVERVIEW", data);
        })
        .catch(async (error) => {
          await console.log(error);
        });
    },
  },
};
